import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetRevenueDto } from "../../../models/analytics/dto/get-revenue.dto";
import { AnalyticsFilterParams, buildFilterSuffix } from "./analyticsFilterParams";

export const GET_REVENUE_QUERY_KEY = 'revenue';

export const useGetRevenue = (locationId: string, startDate?: Date, endDate?: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery<GetRevenueDto>({
        queryKey: [GET_REVENUE_QUERY_KEY, locationId, startDate, endDate, filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            const dateSuffix = startDate && endDate ? `startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}` : '';
            return apiClient.fetchApi<GetRevenueDto, {}>({ method: 'GET', endpoint: `analytics/revenue?locationId=${locationId}&${dateSuffix}${buildFilterSuffix(filters)}` });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
}
